import React from 'react'

import type { DownloadPeriod } from '../../type'
import { CsvDateField } from '../CsvDateField'
import styles from './style.module.css'

type Props = {
  period: DownloadPeriod
  isOverPeriod: boolean
  isBeforeStartDate: boolean
  onStartDateChange: (date: Date) => void
  onEndDateChange: (date: Date) => void
}

export const PeriodSection: React.FC<Props> = ({
  period,
  isOverPeriod,
  isBeforeStartDate,
  onStartDateChange,
  onEndDateChange,
}) => (
  <>
    <h3 className={styles.title}>出力期間</h3>
    <div className={styles.periodRow}>
      <span className={styles.label}>開始日</span>
      <CsvDateField value={period.startDate} onChange={onStartDateChange} />
    </div>
    <div className={styles.periodRow}>
      <span className={styles.label}>終了日</span>
      <CsvDateField value={period.endDate} onChange={onEndDateChange} />
    </div>
    {isOverPeriod && (
      <p className={styles.errorText} role="alert">
        90日間以内で選択してください。
      </p>
    )}
    {!isOverPeriod && isBeforeStartDate && (
      <p className={styles.errorText} role="alert">
        終了日は開始日以降を指定してください。
      </p>
    )}
  </>
)
